var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurServicePrinterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 107,
    viewBox: "0 0 94 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 87.782,
    width: 125,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 0 87.782)",
    fill: "#CEE5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.54199,
    y: 87.8016,
    width: 99.4878,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 9.54199 87.8016)",
    fill: "#FFE2EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 101.882,
    width: 99.4878,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 5 101.882)",
    fill: "#FFF3E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.66 61.5814H62.04C63.4669 61.5814 64.8353 61.0146 65.8442 60.0056C66.8532 58.9967 67.42 57.6282 67.42 56.2014V45.4414C67.42 44.0145 66.8532 42.6461 65.8442 41.6372C64.8353 40.6282 63.4669 40.0614 62.04 40.0614H24.38C22.9531 40.0614 21.5847 40.6282 20.5758 41.6372C19.5668 42.6461 19 44.0145 19 45.4414V56.2014C19 57.6282 19.5668 58.9967 20.5758 60.0056C21.5847 61.0146 22.9531 61.5814 24.38 61.5814H29.76M56.66 40.0614V29.3014C56.66 27.8745 56.0932 26.5061 55.0842 25.4972C54.0753 24.4882 52.7069 23.9214 51.28 23.9214H35.14C33.7131 23.9214 32.3447 24.4882 31.3358 25.4972C30.3268 26.5061 29.76 27.8745 29.76 29.3014V40.0614M29.76 56.2014C29.76 54.7745 30.3268 53.4061 31.3358 52.3972C32.3447 51.3882 33.7131 50.8214 35.14 50.8214H51.28C52.7069 50.8214 54.0753 51.3882 55.0842 52.3972C56.0932 53.4061 56.66 54.7745 56.66 56.2014V66.9614C56.66 68.3882 56.0932 69.7567 55.0842 70.7656C54.0753 71.7746 52.7069 72.3414 51.28 72.3414H35.14C33.7131 72.3414 32.3447 71.7746 31.3358 70.7656C30.3268 69.7567 29.76 68.3882 29.76 66.9614V56.2014Z",
    stroke: "#5B9CD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServicePrinterIcon);
export default __webpack_public_path__ + "static/media/our-service-printer-icon.e7f3c944e466f3afefe3d641b8cf344c.svg";
export { ForwardRef as ReactComponent };